import { ScopeT } from 'business/definitions';
import { keepOnlyBoughtScopes } from 'routes/Admin/UserManagement/Users/helpers';
import { useIntegrationFunctions } from 'helpers/integrations';
import { useSelector } from 'store/hooks';

type EffectiveClientScopes = {
    isLoading: boolean;
    scopes: ScopeT[];
};

/**
 * Hook to get the effective client scopes. It filters the scopes list to only keep the bought scopes.
 * @returns {EffectiveClientScopes} - The effective client scopes
 */
export const useGetEffectiveClientScopes = (): EffectiveClientScopes => {
    const { scopes } = useSelector((state) => state.vision);
    const { data: integrationFunctions, isLoading } = useIntegrationFunctions();
    if (isLoading)
        return {
            isLoading: true,
            scopes: [],
        };
    return {
        isLoading: false,
        scopes: keepOnlyBoughtScopes(scopes, integrationFunctions || new Set()),
    };
};
